import React, { useState, useEffect } from "react";
import "./l002.css";
import kitYellow from "../../assets/translucent_icons/yellow/kit.png";
import kitWhite from "../../assets/translucent_icons/white/kit.png";
import accessoriesYellow from "../../assets/translucent_icons/yellow/accessories.png";
import accessoriesWhite from "../../assets/translucent_icons/white/accessories.png";
import merchandiseYellow from "../../assets/translucent_icons/yellow/merchandise.png";
import merchandiseWhite from "../../assets/translucent_icons/white/merchandise.png";
import colorYellow from "../../assets/translucent_icons/yellow/color.png";
import colorWhite from "../../assets/translucent_icons/white/color.png";
import hotspotYellow from "../../assets/translucent_icons/yellow/hotspot.png";
import hotspotWhite from "../../assets/translucent_icons/white/hotspot.png";
import view_configurationYellow from "../../assets/translucent_icons/yellow/view_configuration.png";
import view_configurationWhite from "../../assets/translucent_icons/white/view_configuration.png";
import configurationYellow from "../../assets/translucent_icons/yellow/configuration.png";
import configurationWhite from "../../assets/translucent_icons/white/configuration.png";
import arrowback from "../../assets/u400c/arrow-left.png";
import leftcurve from "../../assets/left-curve-arrow.png";
import upArrow from "../../assets/up-arrow.png";
import cart from "../../assets/u400c/cart.png";
import rupee from "../../assets/u400c/Rupee.png";
import "react-html5video/dist/styles.css";
import Tooltip from "../../components/tooltip";
import reseticonwhite from "../../../src/assets/Group 2649.png";
import reseticonyellow from "../../../src/assets/Group 2648.png";
import { useDispatch } from "react-redux";
import { setHotspotStatus } from "../../redux/actions/hotspot-action";
import "reactjs-popup/dist/index.css";
import PlaceOrder from "./components/orderModal";
import KitModal from "./components/kitModal";
import FooterItems from "./components/footerItems";
import Menu from "./components/menu";
import { useSelector } from "react-redux";
import { setHotspotClose } from "../../redux/actions/hotspot-close-action";
import HotspotModal from "../../components/hotspotModal";
import VideoModal from "../../components/hotspotVideoModal";
import crossicon from "../../assets/rr310/red-x.png";
import expandIcon from "../../assets/rr310/expand.png";
import cancel from "../../assets/cancel.png";
import axios from "axios";
import SwapItem from "./components/swapItem";
import { setResetStatus } from "../../redux/actions/reset-action";
import { totalPrice } from "../../utils";
import zoomin from "../../assets/pinch-to-zoom.png";
import rotate from "../../assets/drag-to-rotate.png";
import { setMenuStatus } from "../../redux/actions/menu-status-action";
import ExpandIcon from "../../components/expand";
import MerchandiseMenu from "./components/merchandiseMenu";
import { VehicleCode } from "../../config.js";
import ComponentLoader from "../../components/componentLoader";
import Privacy from "./components/privacyPolicy";
import Terms from "./components/termsAndConditons";
import { ConfigBaseUrl } from "../../config.js";
import "react-toastify/dist/ReactToastify.css";
import MercInfo from "./components/MerchandiseInfo/index";
import CartWarning from "./components/addCartWarning/index";

const Configurator = ({
  onConfigurator,
  setExpand,
  fullScreen,
  setResetConfig,
  resetConfig,
  setOnResetStatus,
}) => {
  const [open, setOpen] = useState(false);
  const [videoModel, setVideoModel] = useState(false);
  const [hotspotContent, setHotspotContent] = useState([]);
  const [hotspotBaseUrl, setHotspotBaseUrl] = useState();
  const [longDesc, setLongDesc] = useState(false);
  const [posterUrl, setPosterUrl] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [alloyWheel, setAlloyWheel] = useState(false);
  const [colorSwap, setColorSwap] = useState(false);
  const [modelToggle, setModelToggle] = useState(false);
  const [tooltip, setTooltip] = useState(true);
  const [onHotspot, setHotspot] = useState(false);
  const [viewConfig, setViewConfig] = useState(false);
  const [addKit, setAddKit] = useState(false);
  const [modalText, seModalText] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [kitModal, setKitModal] = useState(false);
  const [orderModal, setOrderModal] = useState(false);
  const [price, setPrice] = useState(0);
  const [reset, setReset] = useState(false);
  const [enableReset, setEnableReset] = useState(false);
  const [enableResetButton, setEnableResetButton] = useState(false);
  const [menuType, setMenuType] = useState("");
  const [merchandise, setMerchandise] = useState(false);
  const [raceNumberStatus, setRaceNumberStatus] = useState(true);
  const [loader, setLoader] = useState(false);
  const [terms, setTerms] = useState(false);
  const [privacy, setPrivacy] = useState(false);
  const [onResetConfig, setOnResetConfig] = useState(resetConfig);
  const [inforModal, setInforModal] = useState(false);
  const [merchInfoDesc, setMerchInfoDesc] = useState("");
  const [cartWarningModal, setCartWarningModal] = useState(false);
  const [warningMessage, setWarningMessage] = useState();
  const [onHover, setOnHover] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastClear, setToastClear] = useState();
  const [crossSellMessage, setCrossSellMessage] = useState("");
  const [crossSellImg, setCrossSellImg] = useState("");

  const dispatch = useDispatch();

  const onHotspotClick = useSelector((state) => state.hotspotClick.status);
  const hotspotdata = useSelector((state) => state.hotspotData.data);
  const customConfigData = useSelector((state) => state.customConfigData.data);

  let curPage = window.location.pathname;

  useEffect(() => {
    setHotspot(addKit);
    dispatch(setHotspotStatus(addKit));
  }, [addKit]);

  useEffect(() => {
    //This function call on hotspot click
    if (onHotspotClick) {
      setOpen(true);
      setHotspotBaseUrl(hotspotdata?.BaseUrl);
      setHotspotContent(
        hotspotdata?.HotspotContent?.filter((i) => i.ID === onHotspotClick)
      );
    }
  }, [onHotspotClick]);

  const onModelClose = () => {
    // document.getElementById("hotspot-icon").style.display = "unset";
    // document.getElementById("color-icon").style.display = "unset";
    setOpen(false);
    setLongDesc(false);
    dispatch(setHotspotClose({ id: onHotspotClick, status: modelToggle }));

    setModelToggle(!modelToggle);
  };

  const onVidelModel = (poster, video) => {
    setPosterUrl(poster);
    setVideoUrl(video);
    setVideoModel(!videoModel);
  };

  useEffect(() => {
    if (drawerOpen === false) {
      customConfigData?.accessoriesData?.map((element) => {
        element?.data?.map((r) => {
          // if (r.ProductCode === "N7224580") {
          //   setRaceNumberStatus(!r.cartStatus);
          // }

          if (r.ProductCode === "N7224580") {
            setRaceNumberStatus(!r.cartStatus);
          }
        });
      });
    }
  }, [drawerOpen, customConfigData]);

  useEffect(() => {
    try {
      setLoader(true);

      const newArray = structuredClone(customConfigData);
      const filterByColorCode = newArray?.partNumber?.filter((x) =>
        newArray?.orderDetails?.some(
          (y) => y.Colour === x?.color?.toLowerCase()
        )
      );

      const getKitArr = newArray?.orderDetails
        ?.filter(
          (obj) => obj.ProductId.includes("k") && obj.ProductId.toUpperCase()
        )
        .map(
          (obj) => obj.ProductId.includes("k") && obj.ProductId.toUpperCase()
        );

      const selectedBtoKit = [...filterByColorCode]?.filter(
        (item) =>
          JSON.stringify(item.kit.sort()) === JSON.stringify(getKitArr.sort())
      );

      axios
        .get(
          ConfigBaseUrl() + `latest-vehicle-prices?vehicleCode=${VehicleCode}`
        )
        .then((response) => {
          if (response) {
            const vehicalPrice = response?.data?.data?.find(
              (item) => item.PartId === selectedBtoKit[0]?.partNumber
            )?.Price;

            setPrice(vehicalPrice);
            customConfigData?.orderDetails?.filter((item) => {
              if (item.Type === "Exshowroom") {
                item.Price = vehicalPrice;
                setLoader(false);
              }
            });
          }
        });
    } catch (error) {
    } finally {
      // setLoader(false);
    }
  }, [customConfigData]);

  const onDrawer = () => {
    setDrawerOpen(false);
    dispatch(setMenuStatus(false));
    setModelToggle(!modelToggle);
    setViewConfig(true);
  };
  const onMerchandiseMenu = () => {
    setMerchandise(false);
    dispatch(setMenuStatus(false));
    setModelToggle(!modelToggle);
    setViewConfig(true);
    onBack();
  };

  const onAlloyWheel = () => {
    setAlloyWheel(!alloyWheel);
    setColorSwap(false);
    setHotspot(false);
    dispatch(setHotspotStatus(false));
  };

  const onColorSwap = () => {
    setColorSwap(!colorSwap);
    setAlloyWheel(false);
    setHotspot(false);
    dispatch(setHotspotStatus(false));
  };

  const onModelHotspot = () => {
    setHotspot(!onHotspot);
    dispatch(setHotspotStatus(!onHotspot));
  };

  const onConfiguration = (value) => {
    setMenuType(value);
    setDrawerOpen(true);
    dispatch(setMenuStatus(true));
    setColorSwap(false);
    setAlloyWheel(false);
    setViewConfig(false);
  };

  const onMerchandise = () => {
    setMerchandise(true);
    dispatch(setMenuStatus(true));
    setColorSwap(false);
    setAlloyWheel(false);
    setViewConfig(false);
  };

  const onBack = () => {
    setAlloyWheel(false);
    setColorSwap(false);
    setViewConfig(false);
    setDrawerOpen(false);
  };
  const onModal = (text) => {
    setModalVisible(true);
    seModalText(text);
  };

  const onResetConfigurator = () => {
    setAddKit(false);
    setEnableReset(false);
    setEnableResetButton(false);
    setOnHover(false);
    setReset(!reset);
    dispatch(setResetStatus(!reset));
    setResetConfig(!onResetConfig);
    setOnResetConfig(!onResetConfig);
    setOnResetStatus(true);
  };

  const createArray = () => {
    if (customConfigData?.orderDetails) {
      customConfigData?.orderDetails?.filter((item) => {
        if (item.Type === "Exshowroom") {
          item.Price = price;
        }
      });
    }
  };

  // function onToastMessage(message) {
  //   setToastMessage(message);
  //   setCartWarningModal(!cartWarningModal);

  //   setTimeout(() => {
  //     setToastMessage("");
  //     setWarningMessage("");
  //     setCartWarningModal(false);
  //   }, 2000);
  // }

  function onToastMessage(message) {
    setToastMessage(message);
    setCartWarningModal(!cartWarningModal);

    const timeoutId = setTimeout(() => {
      setToastMessage("");
      setWarningMessage("");
      setCartWarningModal(false);
    }, 2000);

    setToastClear(timeoutId);
  }

  return (
    <>
      {open && (
        <HotspotModal
          onModelClose={() => onModelClose()}
          modalCloseIcon={crossicon}
          hotspotContent={hotspotContent}
          longDesc={longDesc}
          setLongDesc={() => setLongDesc(true)}
          showMoreIcon={expandIcon}
          hotspotBaseUrl={hotspotBaseUrl}
          onVidelModel={onVidelModel}
        />
      )}

      {videoModel && (
        <div
          // className="modal-bg"
          className="tooltip-bg"
          style={{
            display: " flex",
            alignItems: "center",
            justifyContent: "center",
            opacity: 1,
            zIndex: 5,
            width: "100%",
            height: "100%",
          }}
        >
          <VideoModal
            open={videoModel}
            onClick={() => onVidelModel()}
            closeIcon={cancel}
            posterUrl={posterUrl}
            videoUrl={videoUrl}
          />
        </div>
      )}

      {curPage.includes("RTR310Launch") ? (
        <></>
      ) : (
        <>
          {!open && (
            <div
              className="order_button mediumFont"
              style={{
                right: drawerOpen ? "36rem" : "2.5rem",
                pointerEvents: (loader || price?.length === 0) && "none",
              }}
              onClick={() => setOrderModal(!orderModal)}
            >
              {loader || price?.length === 0 ? (
                <ComponentLoader />
              ) : (
                <>
                  <img
                    className="order_button_rupee"
                    src={rupee}
                    alt="rupee"
                  ></img>
                  {customConfigData?.orderDetails && (
                    <div>
                      {totalPrice(customConfigData)
                        ? totalPrice(customConfigData)
                            ?.toLocaleString("en-IN")
                            .replace(/,/g, " ")
                        : price?.toLocaleString("en-IN").replace(/,/g, " ")}
                      /-
                    </div>
                  )}

                  <img
                    className="order_button_img"
                    src={cart}
                    alt="order"
                  ></img>
                </>
              )}
            </div>
          )}
        </>
      )}

      {tooltip && (
        <div
          className="tooltip-bg"
          onClick={() => {
            setTooltip(false);
            createArray();
            setExpand(true);
            // setStatesModal(!statesModal);
          }}
        ></div>
      )}

      <ExpandIcon fullScreen={fullScreen} setExpand={setExpand} />

      {modalVisible && (
        <div className="modal-bg" onClick={() => setModalVisible(false)}>
          <div
            style={{
              backgroundColor: "#FFF",
              width: "15.8rem",
              height: "3.68rem",
              alignSelf: "center",
              border: "none",
              alignItems: "center",
              justifyContent: "center",
              padding: "1.25rem 4.56rem 1.25rem 4.56rem",
              border: "1px solid #d0d0d0",
              borderRadius: "0.5rem",
            }}
          >
            <div className="modal-alert mediumFont">{modalText}</div>
          </div>
        </div>
      )}

      {orderModal && (
        <div
          // className="modal-bg"
          className="tooltip-bg"
          style={{
            display: " flex",
            alignItems: "center",
            justifyContent: "center",
            opacity: 1,
            zIndex: 5,
            width: "100%",
            height: "100%",
            overflowY: "scroll",
          }}
        >
          <PlaceOrder
            onOrderModal={setOrderModal}
            orderModal={orderModal}
            TermsClick={() => {
              setTerms(true);
            }}
            PrivacyClick={() => {
              setPrivacy(true);
            }}
          />
        </div>
      )}

      {privacy && (
        <div
          // className="modal-bg"
          className="tooltip-bg"
          style={{
            display: " flex",
            alignItems: "center",
            justifyContent: "center",
            opacity: 1,
            zIndex: 5,
            width: "100%",
            height: "100%",
            overflowY: "scroll",
          }}
        >
          <Privacy privacy={privacy} setPrivacy={setPrivacy} />
        </div>
      )}

      {terms && (
        <div
          // className="modal-bg"
          className="tooltip-bg"
          style={{
            display: " flex",
            alignItems: "center",
            justifyContent: "center",
            opacity: 1,
            zIndex: 5,
            width: "100%",
            height: "100%",
            overflowY: "scroll",
          }}
        >
          <Terms setTerms={setTerms} />
        </div>
      )}

      {kitModal && (
        <div
          //className="modal-bg"
          className="tooltip-bg"
          style={{
            display: " flex",
            alignItems: "center",
            justifyContent: "center",
            opacity: 1,
            zIndex: 5,
            overflowY: "scroll",
            width: "100%",
            height: "100%",
          }}
        >
          <KitModal
            onKitModal={setKitModal}
            kitModal={kitModal}
            setAddKit={setAddKit}
            // addCartWarning={(message) => {
            //   setWarningMessage(message);
            //   setCartWarningModal(!cartWarningModal);
            // }}
            warningMessage={setWarningMessage}
            cartWarningModal={setCartWarningModal}
            enableReset={setEnableReset}
          />
        </div>
      )}

      {/* {raceNumModal && (
        <div
          className="tooltip-bg"
          style={{
            display: " flex",
            alignItems: "center",
            justifyContent: "center",
            opacity: 1,
            zIndex: 5,
            overflowY: "scroll",
            width: "100%",
            height: "100%",
          }}
        >
          <RaceNumModal
            onRaceNumModal={setRaceNumModal}
            raceNumModal={raceNumModal}
          />
        </div>
      )} */}
      {cartWarningModal && (
        <div className="modal-bg">
          <CartWarning
            setCartWarningModal={setCartWarningModal}
            onClose={() => {
              setCartWarningModal(false);
              clearTimeout(toastClear);
              setToastMessage("");
              setWarningMessage("");
              setCrossSellMessage("");
              setCrossSellImg("");
            }}
            setWarningMessage={setWarningMessage}
            warningMessage={warningMessage}
            toastMessage={toastMessage}
            setToastMessage={setToastMessage}
            crossSellMessage={crossSellMessage}
            crossSellImg={crossSellImg}
          />
        </div>
      )}

      {drawerOpen && (
        <Menu
          onDrawer={onDrawer}
          menuType={menuType}
          // addCartWarning={(message) => {
          //   setWarningMessage(message);
          //   setCartWarningModal(!cartWarningModal);
          // }}
          enableResetButton={setEnableResetButton}
          warningMessage={setWarningMessage}
          cartWarningModal={setCartWarningModal}
          crossSellMessage={setCrossSellMessage}
          crossSellImg={setCrossSellImg}
        />
      )}
      {merchandise && (
        <MerchandiseMenu
          onDrawer={onMerchandiseMenu}
          enableResetButton={setEnableResetButton}
          menuType={menuType}
          infoModal={(item) => {
            setInforModal(true);
            setMerchInfoDesc(item);
          }}
        />
      )}
      {inforModal && (
        <div
          className="tooltip-bg"
          style={{
            display: " flex",
            alignItems: "center",
            justifyContent: "center",
            opacity: 1,
            zIndex: 5,
            width: "100%",
            height: "100%",
            overflowY: "scroll",
          }}
        >
          <MercInfo
            setInforModal={setInforModal}
            inforModal={inforModal}
            merchInfoDesc={merchInfoDesc}
          />
        </div>
      )}

      {tooltip && (
        <>
          <div
            className="footer-container"
            style={{
              justifyContent: "center",
            }}
          >
            <div className="u400-footer-tooltip">
              <div className="u400-tooltip">
                <div className="hotspot-tooltip-u400">
                  <Tooltip
                    leftcurve={true}
                    image={leftcurve}
                    label={"Select kit of your choice"}
                  />
                </div>
              </div>

              {/* {curPage.includes("RTR310Launch") && (
                <>
                  <div className="u400-tooltip">
                    <div className="tooltip-u400">
                      <Tooltip
                        upArrow={true}
                        image={upArrow}
                        label={
                          "Configure your bike by adding any parts you want"
                        }
                      />
                    </div>
                  </div>

                  <div className="u400-tooltip">
                    <div className="tooltip-u400">
                      <Tooltip
                        upArrow={true}
                        image={upArrow}
                        label={"Select the merchandise"}
                      />
                    </div>
                  </div>
                </>
              )} */}

              {/* <div className="u400-tooltip">
                <div className="tooltip-u400">
                  <Tooltip
                    upArrow={true}
                    image={upArrow}
                    label={"Configure your bike by adding any parts you want"}
                  />
                </div>
              </div>
              <div className="u400-tooltip">
                <div className="tooltip-u400">
                  <Tooltip
                    upArrow={true}
                    image={upArrow}
                    label={"Select the merchandise"}
                  />
                </div>
              </div> */}

              <div className="u400-tooltip">
                <div className="tooltip-u400">
                  <Tooltip
                    upArrow={true}
                    image={upArrow}
                    label={"Change colour of the bike"}
                  />
                </div>
              </div>
              {/* <div className="u400-tooltip">
                <div className="tooltip-u400">
                  <Tooltip
                    upArrow={true}
                    image={upArrow}
                    label={"Select alloy colour"}
                  />
                </div>
              </div> */}
              <div className="u400-tooltip">
                <div className="tooltip-u400">
                  <Tooltip
                    upArrow={true}
                    image={upArrow}
                    label={
                      "Know each part of the bike with the help of hotspots"
                    }
                  />
                </div>
              </div>

              {/* <div className="u400-tooltip">
                <div className="tooltip-u400">
                  <Tooltip
                    upArrow={true}
                    image={upArrow}
                    label={"Select the race number"}
                  />
                </div>
              </div> */}
              {/* <div className="u400-tooltip">
                <div className="tooltip-u400">
                  <Tooltip
                    upArrow={true}
                    image={upArrow}
                    label={"Reset your configuration"}
                  />
                </div>
              </div> */}
            </div>
          </div>

          {curPage.includes("RTR310Launch") ? (
            <></>
          ) : (
            <div className="order-tooltip">
              <Tooltip
                downArrow={true}
                image={upArrow}
                label={
                  "Ex showroom price of the bike. The price keeps updating as you add a new item to it."
                }
              />
            </div>
          )}

          {/* <div className="bike-tooltip">
            <Tooltip rotate={true} image={zoomin} label={"Pinch/scroll for zoom in and zoom out."} />
          </div> */}

          <div className="pinch-to-zoom-tooltip">
            <Tooltip
              zoomin={true}
              image={zoomin}
              label={"Pinch/scroll for zoom in and zoom out."}
            />
          </div>

          <div className="drag-rotate-tooltip">
            <Tooltip rotate={true} image={rotate} label={"Drag to rotate"} />
          </div>
        </>
      )}
      {(addKit || enableResetButton) &&
        !drawerOpen &&
        !merchandise &&
        !viewConfig &&
        !alloyWheel &&
        !colorSwap &&
        !open && (
          <div
            className="reset_button_container"
            onClick={() => {
              if (addKit || enableResetButton) {
                onResetConfigurator();
                setHotspot(false);
                dispatch(setHotspotStatus(false));
              }
            }}
            onMouseEnter={() => setOnHover(true)}
            onMouseLeave={() => setOnHover(false)}
          >
            <img
              className="reset_button_icon"
              src={onHover ? reseticonyellow : reseticonwhite}
              alt="resetIcon"
            />
            <div
              className="reset_text boldFont"
              style={{ color: onHover ? "#ffe100" : "white" }}
            >
              Reset Configuration
            </div>
          </div>
        )}

      <div
        className="footer-container"
        style={{
          justifyContent:
            drawerOpen || merchandise || viewConfig ? "flex-start" : "center",
        }}
      >
        <div className="u400-footer-container">
          {!open && (
            <div
              className="on-back"
              style={{ top: alloyWheel || colorSwap ? "0.07rem" : "-0.07rem" }}
              onClick={() => {
                drawerOpen ||
                merchandise ||
                alloyWheel ||
                colorSwap ||
                viewConfig
                  ? onBack()
                  : onConfigurator(0);
              }}
            >
              <img src={arrowback} alt="back"></img>
            </div>
          )}
          <div className="u400-footer">
            {(colorSwap || alloyWheel) && (
              <SwapItem
                addKit={addKit}
                colorSwap={colorSwap}
                alloyWheel={alloyWheel}
                enableReset={setEnableReset}
                OnToastMsg={(message) => onToastMessage(message)}
              />
            )}

            {drawerOpen && (
              <FooterItems
                imageYellow={view_configurationYellow}
                imageWhite={view_configurationWhite}
                label={"View Configurator"}
                onClick={() => onDrawer()}
              />
            )}
            {viewConfig && (
              <FooterItems
                imageYellow={configurationYellow}
                imageWhite={configurationWhite}
                label={"Continue Configuration"}
                onClick={() => onConfiguration()}
              />
            )}

            {!drawerOpen &&
              !merchandise &&
              !viewConfig &&
              !alloyWheel &&
              !colorSwap &&
              !open && (
                <>
                  <FooterItems
                    imageYellow={kitYellow}
                    imageWhite={kitWhite}
                    label={"BTO Kit"}
                    onClick={() => {
                      setKitModal(!kitModal);
                      setHotspot(false);
                      dispatch(setHotspotStatus(false));
                    }}
                  />

                  {curPage.includes("RTR310Launch") && (
                    <>
                      <FooterItems
                        imageYellow={kitYellow}
                        imageWhite={kitWhite}
                        label={"Accessories"}
                        onClick={() => {
                          onConfiguration("Accessories");
                          setHotspot(false);
                          dispatch(setHotspotStatus(false));
                        }}
                      />
                      <FooterItems
                        imageYellow={merchandiseYellow}
                        imageWhite={merchandiseWhite}
                        label={"Merchandise"}
                        onClick={() => {
                          onMerchandise("Merchandise");
                          setHotspot(false);
                          dispatch(setHotspotStatus(false));
                        }}
                      />
                    </>
                  )}
                  {/* <FooterItems
                    imageYellow={accessoriesYellow}
                    imageWhite={accessoriesWhite}
                    label={"Accessories"}
                    onClick={() => {
                      onConfiguration("Accessories");
                      setHotspot(false);
                      dispatch(setHotspotStatus(false));
                    }}
                  />

                  <FooterItems
                    imageYellow={merchandiseYellow}
                    imageWhite={merchandiseWhite}
                    label={"Merchandise"}
                    onClick={() => {
                      onMerchandise("Merchandise");
                      setHotspot(false);
                      dispatch(setHotspotStatus(false));
                    }}
                  /> */}
                  <FooterItems
                    imageYellow={colorYellow}
                    imageWhite={colorWhite}
                    label={"Color"}
                    onClick={() => (addKit ? onColorSwap() : onColorSwap())}
                    addKit={addKit}
                    // disable={true}
                  />
                  {/* <FooterItems
                    image={wheel}
                    label={"Alloy Wheel"}
                    onClick={() =>
                      addKit
                        ? onAlloyWheel()
                        : onModal("Please choose a kit to proceed.")
                    }
                    addKit={addKit}
                    disable={true}
                  /> */}

                  <FooterItems
                    imageYellow={hotspotYellow}
                    imageWhite={hotspotWhite}
                    label={"Hotspot"}
                    onClick={() =>
                      addKit
                        ? onModelHotspot()
                        : onToastMessage("Please choose a kit to proceed.")
                    }
                    addKit={addKit}
                    disable={true}
                    onClicked={onHotspot}
                  />

                  {/* <FooterItems
                    image={kit}
                    label={"Race Number"}
                    onClick={() => {
                      if (!raceNumberStatus) {
                        setRaceNumModal(!raceNumModal);
                        setHotspot(false);
                        dispatch(setHotspotStatus(false));
                      } else {
                        onModal("Please choose a visor to proceed.");
                      }
                    }}
                    disable={raceNumberStatus}
                  /> */}

                  {/* <FooterItems
                    image={updateLeftRotation}
                    label={"Reset"}
                    onClick={() => {
                      if (addKit) {
                        onResetConfigurator();
                        setHotspot(false);
                        onToastMessage("Configuration reset is successful");
                        dispatch(setHotspotStatus(false));
                      }
                    }}
                    addKit={addKit}
                    disable={true}
                    // enableReset={enableReset}
                    clickable={true}
                  /> */}
                </>
              )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Configurator;
